import cloneDeep from 'lodash/cloneDeep';

export const statsTypes = Object.freeze({
    PLAYER: 'player-stats',
    HOLE: 'hole-stats'
});

export const statsNames = Object.freeze({
    FAIRWAY_HITS: 'fairwayHits',
    GREENS_IN_REGULATION: 'greensInRegulation',
    AVERAGE_NUMBER_OF_PUTTS: 'averageNumberOfPutts',
    BIGGEST_HITTERS: 'biggestHitters',
    HARDEST_HOLES: 'hardestHoles',
    EASIEST_HOLES: 'easiestHoles',
    HARDEST_GREENS_TO_REACH: 'hardestGreensToReach',
    HARDEST_GREENS_TO_PLAY: 'hardestGreensToPlay'
});

const statsCards = [
    {
        name: statsNames.FAIRWAY_HITS,
        type: statsTypes.PLAYER,
        trackName: 'Fairway Hits'
    },
    {
        name: statsNames.GREENS_IN_REGULATION,
        type: statsTypes.PLAYER,
        trackName: 'Greens In Regulation'
    },
    {
        name: statsNames.AVERAGE_NUMBER_OF_PUTTS,
        type: statsTypes.PLAYER,
        trackName: 'Average Number of Putts per Greens In Regulation'
    },
    {
        name: statsNames.BIGGEST_HITTERS,
        type: statsTypes.PLAYER,
        trackName: 'Biggest Hitters'
    },
    {
        name: statsNames.HARDEST_HOLES,
        type: statsTypes.HOLE,
        trackName: 'Hardest Holes'
    },
    {
        name: statsNames.EASIEST_HOLES,
        type: statsTypes.HOLE,
        trackName: 'Easiest Holes'
    },
    {
        name: statsNames.HARDEST_GREENS_TO_REACH,
        type: statsTypes.HOLE,
        trackName: 'Hardest Greens To Reach'
    },
    {
        name: statsNames.HARDEST_GREENS_TO_PLAY,
        type: statsTypes.HOLE,
        trackName: 'Hardest Greens To Play'
    }
];

export const getStatsCards = () => {
    return cloneDeep(statsCards);
};

export const typeChoices = [
    {
        label: 'All stats',
        value: 'all',
        selected: true
    },
    {
        label: 'Player stats',
        value: statsTypes.PLAYER,
        selected: false
    },
    {
        label: 'Hole stats',
        value: statsTypes.HOLE,
        selected: false
    },
];
